import { render, staticRenderFns } from "./SagePaySlipForm.vue?vue&type=template&id=5a7ef190&scoped=true&"
import script from "./SagePaySlipForm.vue?vue&type=script&lang=js&"
export * from "./SagePaySlipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ef190",
  null
  
)

export default component.exports